/*
 * dispenseEproDevicePopupModule
 * */

import closeEproDevicePopupComponent from './closeEproDevicePopup.component';

const closeEproDevicePopupModule = angular.module('app.components.closeEproDevicePopup', [])
	.component('closeEproDevicePopup', closeEproDevicePopupComponent)
	.name;

export default closeEproDevicePopupModule;
